<template>
  <div id="app">
    <router-view :baseData="baseData" v-if="baseData"/>
    <a href="http://h5.thepage.cn/315cxb/" style="position: absolute;width: 1rem;height: 1rem;left: 4.5rem;top: 3rem;z-index: 20;"></a>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import COVER from '@/utils/COVER'

export default {
  data() {
    return {
      baseData: null
    }
  },
  computed: {
    ...mapState(['aid'])
  },
  created() {
    this.getActivityData()
  },
  methods: {
    getActivityData() {
        COVER.$request('/activity/getdata', {
            aid: this.aid
        }).then((res) => {
            if(res.errno == 0 && res.data) {
                this.baseData = res.data
            }
        })
    },
  }

}
</script>
